import ApiClient from '@/libs/http-client'

const ProjectsService = {
    endpoints(route, param ) {
        const url = {
            personalTasks: '/api/tasks/my',
            taskStatuses: '/api/tasks/statuses',
            changeTaskStatus: `api/tasks/${param}`,
            getCurrentTask: `api/tasks/${param}`,
            getCurrentTaskByTag: `api/tasks/tag/${param}`,

            getCurrentTaskInfo: `api/projects/slug/${param}/info`,
            changeOrder: `api/projects/${param}/statuses/positions`,
            userProjects: `/api/users/${param}/projects`,
            userTasks: `/api/users/${param}/tasks`,
            todos: `/api/tasks/${param}/todos`,
            comments: `/api/tasks/${param}/comments`,
            createTask: '/api/tasks/',
            deleteTask: `/api/tasks/${param}`,
            editTask: `/api/tasks/${param}`,
            editProject: `/api/projects/${param}`,
            activeProjects: '/api/projects?active=1',
            projects: '/api/projects',
            allClients: '/api/clients',
            kanbanBoards: '/api/tasks/statuses',
            clients: `/api/users?role_id=2&author_id=${param}`,
            projectTasks: `/api/tasks?project_id=${param}`,

            projectTasksParent: `/api/tasks?project_id=${param.id}&statuses=${param.statuses}`,

            projectSlug: `/api/projects/slug/${param}`,
            taskSlug: `/api/projects/${param.project}/tasks/tag/${param.task}`,
            toggleBoard: `/api/projects/${param.id}/statuses/${param.board}`,

            getReleases: `/api/projects/${param}/releases`,
            getTasksForRelease: `/api/tasks?project_id=${param}&can_be_added_to_release=1`,
            getCurrentRelease: `/api/projects/${param.project}/releases/${param.id}`,
            getReleaseOptions: `/api/projects/${param}/releases?status=in_progress`
            // deleteRelease: `/api/projects/${param.projectIdId}/releases/${param.releaseId}`,
        };

        return url[route];
    },
    get(url, params = {}) {
        return ApiClient.get(this.endpoints(url, params));
    },
    put(url, params = {}, data, config = {}) {
        return ApiClient.put(this.endpoints(url, params), data, config);
    },
    post(url, params = {}, data, config = {}) {
        return ApiClient.post(this.endpoints(url, params), data, config);
    },
    patch(url, params = {}, data, config = {}) {
        return ApiClient.patch(this.endpoints(url, params), data, config);
    },
    delete(url, params = {}, config = {}) {
        return ApiClient.delete(this.endpoints(url, params), config);
    },
    getTaskComments(id, config = {}) {
        return ApiClient.get(`/api/tasks/${id}/comments`, config);
    },
    createNewTaskComment(id, data, config = {}) {
        return ApiClient.post(`/api/tasks/${id}/comments`, data, config);
    },
    editNewTaskComment(taskId, commentId, data, config = {}) {
        return ApiClient.put(`/api/tasks/${taskId}/comments/${commentId}`, data, config);
    },
    editTodo(taskId, commentId, data, config = {}) {
        return ApiClient.put(`/api/tasks/${taskId}/todos/${commentId}`, data, config);
    },
    release(projectId, releaseId, data, config = {}) {
        return ApiClient.put(`/api/projects/${projectId}/releases/${releaseId}`, data, config);
    },
    addProjectInfo(slug, data, config = {}) {
        return ApiClient.put(`/api/projects/slug/${slug}/info`, data, config);
    },
    deleteNewTaskComment(taskId, commentId, config = {}) {
        return ApiClient.delete(`/api/tasks/${taskId}/comments/${commentId}`, config);
    },
    deleteRelease(projectId, releaseId, config = {}) {
        return ApiClient.delete(`/api/projects/${projectId}/releases/${releaseId}`, config);
    },
    clearBoard(project, board, config = {}) {
        return ApiClient.delete(`/api/tasks?project_id=${project}&status=${board}`, config);
    },
    deleteTodo(taskId, commentId, config = {}) {
        return ApiClient.delete(`/api/tasks/${taskId}/todos/${commentId}`, config);
    },
    getTaskStatuses(config) {
        return ApiClient.get('/api/tasks/statuses', config)
    },
    addNewComment(id, data, config) {
        return ApiClient.post(`/api/tasks/${id}/comments`, data, config)
    },
    createRelease(id, data, config) {
        return ApiClient.post(`/api/projects/${id}/releases`, data, config)
    },
    addTodo(id, data, config) {
        return ApiClient.post(`/api/tasks/${id}/todos`, data, config)
    },
    createNewTask(data, config) {
        return ApiClient.post('/api/tasks', data, config)
    },

    createNewProject(data, config) {
        return ApiClient.post('/api/projects', data, config)
    },

}

export default ProjectsService
